import React, {useEffect, useState} from 'react';
import {useNavigate, useLocation} from "react-router-dom";

import JsonView from 'react18-json-view'

import {getParentPath} from "ultra/helpers/route";
import {getUrl, getClientConfig} from "ultra/configs/general";
import {normalizeRoute, restorePath, revertPath} from "ultra/helpers/route";
import {DEFAULT_CITY} from 'ultra/const/general';
import {getClientCity} from 'ultra/configs/general';
import {hasChildrenValidatePermitsByType, isAdmin} from 'ultra/helpers/auth';

import {useNavigationStore} from '../../../../Stores/navigation';
import {useBackdropPreloaderStore} from '../../../../Stores/backdropPreloader';
import {useGlobalCustomContext} from '../../../../Helpers/context';
import {useToasterStore} from '../../../../Stores/toster';
import {useConfigStore} from '../../../../Stores/config';
import {useContentStore} from '../../../../Stores/content'
import {useSearchStore} from '../../../../Stores/search'

import CKEditorContent from '../../Widgets/CKEditorContent';

import FormContainer from '../../../../Components/Form/FormContainer';
import PreloaderForm from '../../../../Components/Preloaders/PreloaderForm';
import AdaptiveDialog from '../../../../Components/Adaptive/Dialog';

import {getNodeForm, getConfigs} from '../../../../Helpers/config'
import {cleanCacheStore} from '../../../../Helpers/cache'
import {getNodeContent, getNodeByDIDContent, getFormByDIDContent, removeContent, validateContent, getNodeTypeTitle} from '../../../../Helpers/content';

import {NODE_ACTIONS} from '../../Reducers/node';
import {USER_ACTIONS} from '../../../Profile/Reducers/user';
import {removeContentUnusedFiles} from '../../../Profile/Helpers/content';

import {getVirtualUri} from '../../../../Helpers/content';

import './index.scss'

function NodeAdd(props) {
    const {pageConfig, customConfig, beforeSubmit, afterSubmit, formActions} = props;
  
    const {userState} = useGlobalCustomContext();

    return <>
        <div className='NodeContent'>
            {isAdmin(userState?.user)
                && customConfig && <div className='pathValues'>
                        <div className="label">Path mask values:</div>
                        <JsonView
                            src={customConfig}
                            theme='a11y'
                            editable={false}
                            collapsed={false}
                            enableClipboard={false}
                            collapseStringsAfterLength={6}
                        />
                    </div>
            }

            <FormContainer
                formActions={formActions}
                config={pageConfig?.config}
                afterSubmit={afterSubmit}
                beforeSubmit={beforeSubmit}
            />
        </div>
    </>
}
  
function NodeEdit(props) {
    const {pageConfig, customConfig, afterSubmit, beforeSubmit, formActions} = props;
  
    const {userState} = useGlobalCustomContext();

    if (pageConfig?.form?.form) {
        pageConfig.form.form.submitText = 'Оновити'
    }

    return <>
        <div className='NodeContent'>
            {isAdmin(userState?.user)
                && customConfig && <div className='pathValues'>
                    <div className="label">Path mask values:</div>
                    <JsonView
                        src={customConfig}
                        theme='a11y'
                        editable={false}
                        collapsed={false}
                        enableClipboard={false}
                        collapseStringsAfterLength={6}
                    />
                </div>
            }

            <FormContainer
                isEditMode={true}
                config={pageConfig?.form}
                content={pageConfig?.page?.content}
                afterSubmit={afterSubmit}
                beforeSubmit={beforeSubmit}
                formActions={formActions}
            />
        </div>
    </>
}

export default function NodePopups() {
    const navigate = useNavigate();
    const location = useLocation();

    const {setConfig} = useConfigStore();
    const {stopLoading} = useNavigationStore();

    const {
        search,
        validatePageSearchResult,
        updateSearchResult,
        renameSearchResult,
        deleteSearchResult
    } = useSearchStore();

    const {
        content,
        updatePage,
        validatePage,
        validatePageVirualUri,
        renamePages,
        renamePagesVirtualUri,
        addChildNode,
        updatePageVirtualUri,
        addChildNodeVirtualUri,
        deleteChildNodesVirtualUri,
        deleteChildNode
    } = useContentStore();

    const {showPromt, showError, closeToaster} = useToasterStore();
    const {showBackdropPreloader, hideBackdropPreloader} = useBackdropPreloaderStore()
    const {nodeState, nodeDispatch, userDispatch} = useGlobalCustomContext();

    const [pageConfig, setPageConfig] = useState();

    const [isConfigLoading, setIsConfigLoading] = useState(false);

    const formActions = {
        disable: function () {
            showBackdropPreloader()
        },
        enable: function () {
            hideBackdropPreloader()
        }
    }

    useEffect(() => {
        const keyDownHandler = event => {
            if (event.key === 'Escape') {
                event.preventDefault();

                nodeDispatch({type: NODE_ACTIONS.POPUPS_CLOSE});
            }
        };

        document.addEventListener('keydown', keyDownHandler);

        return () => {
            document.removeEventListener('keydown', keyDownHandler);
        };
    }, [])

    useEffect(() => {
        if (nodeState) {

            if (nodeState.popupFormOpen) {
                setIsConfigLoading(true)
                setPageConfig({})

                getFormByDIDContent(nodeState.popupFormOpen)
                    .promise
                    .then(config => {
                        if (!config.form.endpoint) {
                            config.page.content.form.endpoint = '/form/' + nodeState.popupFormOpen.city + '/form/' + config.page.content._uri;
                        }

                        setPageConfig(config)
                        setIsConfigLoading(false)
                    })
            }

            if (nodeState.popupPageOpen) {
                setIsConfigLoading(true)
                setPageConfig({})
                
                getNodeByDIDContent(nodeState.popupPageOpen)
                    .promise
                    .then(config => {
                        setPageConfig(config)
                        setIsConfigLoading(false)
                    })
            }

            if (nodeState.addPopupOpen) {
                setIsConfigLoading(true)
                setPageConfig({})

                const path = {
                    city: getClientCity(window) || DEFAULT_CITY,
                    uri: nodeState.addPopupOpen.parent
                };

                getNodeContent(path)
                    .promise
                    .then(config => {
                        getNodeForm(nodeState.addPopupOpen.type, nodeState.addPopupOpen.parent)
                            .promise
                            .then(formConfig => {
                                if (!hasChildrenValidatePermitsByType(config.permits, nodeState.addPopupOpen.type)) {
                                    formConfig.form.submitNotice = 'Сторінку буде опубліковано після перевірки модератором'
                                }

                                const city = getClientCity(window) || DEFAULT_CITY;
                                formConfig.form.endpoint = formConfig.form.endpoint + '/' + city + '/path' + window.location.pathname;

                                setPageConfig({type: nodeState.addPopupOpen.type, config: formConfig})
                                setIsConfigLoading(false)
                            });  
                    })
            }

            if (nodeState.editPopupOpen) {
                setIsConfigLoading(true)
                setPageConfig({})

                getNodeContent(nodeState.editPopupOpen, '?edit=true')
                    .promise
                    .then(config => {
                        config.form.form.endpoint = config.form.form.endpoint + '/' + nodeState.editPopupOpen.city + '/path' + revertPath(nodeState.editPopupOpen.uri);
                        if (!config.permits.validate && !config.page.content._published) {
                            config.form.form.submitNotice = 'Сторінку буде опубліковано після перевірки модератором'
                        }

                        setPageConfig(config)
                        setIsConfigLoading(false)
                    })
                    .catch(err => {
                        hidePopups();
                        showError({snackbarMessage: `${err.message}. Оновіть сторінку та спробуйте ще раз`});
                    })
            }
        
            if (nodeState.validateStart || nodeState.unvalidateStart) {
                showBackdropPreloader();

                validateContent(nodeState.validateStart || nodeState.unvalidateStart)
                    .then(async (result) => {
                        if (getVirtualUri()) {
                            validatePageVirualUri(result._published, (nodeState.validateStart || nodeState.unvalidateStart))
                        }
                        else {
                            validatePage(result._published, (nodeState.validateStart || nodeState.unvalidateStart))
                        }

                        if (search.result?.children) {
                            validatePageSearchResult(result._published, (nodeState.validateStart || nodeState.unvalidateStart))
                        }

                        nodeDispatch({type: NODE_ACTIONS.UPDATE_PAGE_CONTENT_START})
                    })
                    .catch((err) => {
                        hidePopups();
                        showError({snackbarMessage: err.message});
                    })

                nodeDispatch({type: NODE_ACTIONS.VALIDATE_CLEANED})
                nodeDispatch({type: NODE_ACTIONS.UNVALIDATE_CLEANED})    
            }
        
            if (nodeState.deletePopupOpen) {
                showBackdropPreloader();
        
                // TODO: addd check has childrens or not
                // setHasChildren(pageConfig.children.list && Object.keys(pageConfig.children.list).length > 0)
        
                showPromt({
                    // snackbarMessage: hasChildren ? 'У цієї сторінки є вкладені вузли, видалити всі?' : 'Ви впевнені що бажаєте видалити сторінку?',
                    snackbarMessage: 'Ви впевнені що бажаєте видалити сторінку?',
                    snackbarDuration: 10000,
                    onApproveHandler: onRemoveNodeHandler,
                    onCloseHandler: () => {
                        nodeDispatch({type: NODE_ACTIONS.DELETE_CLEAN})
                        hidePopups();
                    }
                })
            }

            if (nodeState.updatePageContentStart) {
                nodeDispatch({type: NODE_ACTIONS.UPDATE_PAGE_CONTENT_END});
                hidePopups();
            }
        }
    }, [nodeState])

    const beforeSubmit = () => {
        // clean cache for nodes
        const path = revertPath(normalizeRoute(location.pathname));
        cleanCacheStore('nodes', path);
    }

    const afterSubmit = (mode) => {
        return ({result}) => new Promise(async resolve => {
            function successHandler() {
                nodeDispatch({type: NODE_ACTIONS.UPDATE_PAGE_CONTENT_START})

                if (result.succesfullyRenamed) {
                    if (getVirtualUri()) {
                        renamePagesVirtualUri(result.succesfullyRenamed)
                    }
                    else {
                        renamePages(result.succesfullyRenamed)
                    }

                    if (search.result?.children) {
                        renameSearchResult(result.succesfullyRenamed)
                    }
                }

                else if (mode === 'edit') {
                    if (getVirtualUri()) {
                        updatePageVirtualUri(result)
                    }
                    else {
                        updatePage(result)
                    }

                    if (search.result?.children) {
                        updateSearchResult(result)
                    }
                }

                else if (mode === 'add') {
                    if (getVirtualUri()) {
                        addChildNodeVirtualUri(
                            {
                                ...result.page,
                                _uri: result._uri
                            },
                            result.permits
                        )
                    }
                    else {
                        addChildNode(
                            {
                                ...result.page,
                                _uri: result._uri
                            },
                            result.permits
                        )
                    }

                    if (search.result?.children) {
                        updateSearchResult(result)
                    }
                }

                setPageConfig(null);

                hidePopups();

                resolve();
            }

            const path = normalizeRoute(location.pathname);

            userDispatch({type: USER_ACTIONS.USER_REFRESH_START})

            setConfig(await getConfigs().promise);

            // if after rename current path in the list of changed, should be navigation to new page
            switch(mode) {
                case 'edit':
                    if (result.succesfullyRenamed?.[revertPath(path)]) {
                        navigate(restorePath(getParentPath(result.succesfullyRenamed[revertPath(path)]._uri)));
                        hidePopups();
                    }
                    else {
                        successHandler();
                    }
                    break;

                case 'add':
                    successHandler();
                    break;
            }
        })
    }

    const onRemoveNodeHandler = () => {
        closeToaster()

        removeContent(nodeState.deletePopupOpen)
            .then(async () => {
                nodeDispatch({type: NODE_ACTIONS.DELETE_FINISHED})
                if (search.result?.children) {
                    deleteSearchResult(nodeState.deletePopupOpen.uri)
                }

                if (getVirtualUri()) {
                    deleteChildNodesVirtualUri(nodeState.deletePopupOpen.uri)
                }
                else {
                    deleteChildNode(nodeState.deletePopupOpen.uri)
                }
            })
            .catch((err) => {
                hidePopups();
                showError({snackbarMessage: err.message})
                nodeDispatch({type: NODE_ACTIONS.DELETE_FINISHED})
        })
    }

    const hidePopups = () => {
        nodeDispatch({type: NODE_ACTIONS.POPUPS_CLOSE});

        // after drawler closed delay to hide preloader
        setTimeout(() => {
            stopLoading();
            hideBackdropPreloader();
        }, 500)
    }

    const onClose = () => {
        hidePopups();

        return new Promise(async (resolve) => {
                const did = pageConfig?.config?.defaultValues?._did || pageConfig?.page?.content?._did;
                const city = nodeState?.editPopupOpen?.city || getClientCity(window) || DEFAULT_CITY;

                await removeContentUnusedFiles(city, did);

                setIsConfigLoading(false);

                setPageConfig(null);

                resolve();
        });
    }

    const goToPage = (pageCity, uri) => {
        const city = getClientCity(window) || DEFAULT_CITY;

        if (pageCity === city) {
            navigate(restorePath(getParentPath(uri)))
        }
        else {
            const {domain} = getClientConfig(window);
            window.open(getUrl(domain, pageCity, restorePath(getParentPath(uri))), "_self")
        }

        nodeDispatch({type: NODE_ACTIONS.POPUPS_CLOSE});
    }

    return <>
        <AdaptiveDialog open={Boolean(nodeState?.popupFormOpen)} onClose={hidePopups} title={pageConfig?.page?.content?.title}>
            {isConfigLoading && <PreloaderForm />}
        
            {!isConfigLoading && nodeState?.popupFormOpen && <FormContainer
                formActions={formActions}
                config={pageConfig?.page?.content}
                afterSubmit={onClose}
            />}
        </AdaptiveDialog>

        <AdaptiveDialog open={Boolean(nodeState?.popupPageOpen)} onClose={hidePopups} title={pageConfig?.page?.content?.title}>
            {isConfigLoading && <PreloaderForm />}
            
            {!isConfigLoading && nodeState?.popupPageOpen && <CKEditorContent content={pageConfig?.page?.content?.description} />}
            {pageConfig?.children?.order?.length > 0 && <ul>{pageConfig.children.order.map(i => 
                pageConfig.children.permits[i].read && <li><span className='pseudoLink' onClick={() => goToPage(pageConfig.city, i)}>{pageConfig.children.list[i].title}</span></li>
            )}</ul>}
        </AdaptiveDialog>

        <AdaptiveDialog open={Boolean(nodeState?.editPopupOpen)} onClose={onClose} title={getNodeTypeTitle(pageConfig?.form?.title || pageConfig?.form?.form?.title, 'Редагувати')}>
            {isConfigLoading && <PreloaderForm />}

            {!isConfigLoading && nodeState?.editPopupOpen && <NodeEdit
                onClose={onClose}
                formActions={formActions}
                pageConfig={pageConfig}
                customConfig={pageConfig?.page?.config?.values?.[pageConfig?.page?.content?._type]}
                currentPage={pageConfig?.page?.content}
                breadcrumbs={pageConfig?.breadcrumbs}
                beforeSubmit={beforeSubmit}
                afterSubmit={afterSubmit('edit')}
            />}
        </AdaptiveDialog>

        <AdaptiveDialog open={Boolean(nodeState?.addPopupOpen)} onClose={onClose} title={getNodeTypeTitle(pageConfig?.config?.title || pageConfig?.config?.form?.title, 'Додати')}>
            {isConfigLoading && <PreloaderForm />}

            {!isConfigLoading && nodeState?.addPopupOpen && <NodeAdd
                onClose={onClose}
                formActions={formActions}
                pageConfig={pageConfig}
                customConfig={pageConfig?.page?.config?.values?.[pageConfig?.type]}
                currentPage={pageConfig?.page?.content}
                breadcrumbs={pageConfig?.breadcrumbs}
                beforeSubmit={beforeSubmit}
                afterSubmit={afterSubmit('add')}
            />}
        </AdaptiveDialog>
    </>
}
